import actions from './actions'
import mutations from './mutations'

let state = {
    all: null,
    collection: null,
    count: 0,
    current: null,    
    currentAddresses: [],
    currentHabilitations: [],  
    page: 1
}

const ACTIONS = {
    ADD: 'utilisateurs/add',
    GET: 'utilisateurs/get',
    GET_ALL: 'utilisateurs/getALl',
    GET_COLLECTION: 'utilisateurs/getCollection',
    GET_ADDRESSES: 'utilisateurs/getAddresses',
    GET_HABILITATIONS: 'utilisateurs/getHabilitations',
    GET_NEXT: 'utilisateurs/getNext',
    UPDATE: 'utilisateurs/update'
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}

export { ACTIONS as actions }